import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { InvoiceValidationChecklistComponent } from '../../invoice/components/invoice-validation-checklist/invoice-validation-checklist.component';
import { InvoiceDataService } from '../../invoice/services/invoice-data.service';
import { PhoenixCommonModule } from '../PhoenixCommon.module';
import { RuleComplianceModule } from '../rule-compliance/rule-compliance.module';
import { PanelChecklistRuleComponent } from './components/panel-checklist-rule/panel-checklist-rule.component';
import { PhxPanelBarComponent } from './components/phx-panel-bar/phx-panel-bar.component';
import { PhxPanelChecklistComponent } from './components/phx-panel-checklist/phx-panel-checklist.component';
import { PhxPanelCustomComponent } from './components/phx-panel-custom/phx-panel-custom.component';
import { PhxPanelNotesComponent } from './components/phx-panel-notes/phx-panel-notes.component';
import { PhxPanelVersionComponent } from './components/phx-panel-version/phx-panel-version.component';
import { PhxPanelMessagesComponent } from './components/phx-panel-messages/phx-panel-messages.component';

@NgModule({
  declarations: [
    PhxPanelBarComponent,
    PhxPanelChecklistComponent,
    PhxPanelCustomComponent,
    PhxPanelNotesComponent,
    PhxPanelVersionComponent,
    PhxPanelMessagesComponent,
    PanelChecklistRuleComponent,
    InvoiceValidationChecklistComponent
  ],
  imports: [
    CommonModule,
    PhoenixCommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    RuleComplianceModule,
    NgxSkeletonLoaderModule
  ],
  providers: [
    InvoiceDataService
  ],
  exports: [
    PhxPanelBarComponent,
    PhxPanelCustomComponent
  ]
})
export class PanelBarModule { }
